import { RouteObject, useRoutes } from "react-router";
import { APP_URLS, AUTH_ROOT } from "urls/AppUrls";
import {
  LoadableContactUsDetailsPage,
  LoadableContactUsPage,
  LoadableError401Page,
  LoadableError403Page,
  LoadableError404Page,
  LoadableError500Page,
  LoadableLoginPage,
  LoadableDefaultLayoutPage,
  LoadableFactManagerPage,
  LoadableFactManagerListPage,
  LoadableOrganizationsListPage,
  LoadableOrganizationPage,
} from "./elements";
import AuthGuard from "guards/AuthGuard";
import GuestGuard from "guards/GuestGuard";
import PermissionBasedGuard from "guards/PermissionBasedGuard";
import { FACT_PERMISSIONS, WAREHOUSE_PERMISSIONS } from "constants/permissions";

export default function Router() {
  const allRoutes: Array<RouteObject> = [
    {
      path: APP_URLS.ROOT,
      element: (
        <GuestGuard>
          <LoadableLoginPage />
        </GuestGuard>
      ),
    },
    {
      path: APP_URLS.LOGIN,
      element: (
        <GuestGuard>
          <LoadableLoginPage />
        </GuestGuard>
      ),
    },
    {
      path: APP_URLS.LOGOUT,
      element: (
        <GuestGuard>
          <LoadableLoginPage />
        </GuestGuard>
      ),
    },
    {
      path: APP_URLS.PAGES.CONTACT_US,
      element: <LoadableContactUsPage />,
    },
    {
      path: APP_URLS.PAGES.CONTACT_DETAILS,
      element: <LoadableContactUsDetailsPage />,
    },
    {
      path: APP_URLS.PAGES.ERROR_401,
      element: <LoadableError401Page />,
    },
    {
      path: APP_URLS.PAGES.ERROR_403,
      element: <LoadableError403Page />,
    },
    {
      path: APP_URLS.PAGES.ERROR_404,
      element: <LoadableError404Page />,
    },
    {
      path: APP_URLS.PAGES.ERROR_500,
      element: <LoadableError500Page />,
    },
    {
      path: AUTH_ROOT,
      element: (
        <AuthGuard>
          <LoadableDefaultLayoutPage />
        </AuthGuard>
      ),
      children: [
        {
          path: APP_URLS.HOME,
          element: <PermissionBasedGuard
            permissions={[
              FACT_PERMISSIONS.CAN_READ_FACTS,
            ]}
          ><LoadableFactManagerListPage /></PermissionBasedGuard>,
        },
        {
          path: APP_URLS.FACT_MANAGER.ROOT,
          element: <PermissionBasedGuard
            permissions={[
              FACT_PERMISSIONS.CAN_READ_FACTS,
            ]}
          ><LoadableFactManagerListPage /></PermissionBasedGuard>,
        },
        {
          path: APP_URLS.FACT_MANAGER.ITEM,
          element: <PermissionBasedGuard
            permissions={[
              FACT_PERMISSIONS.CAN_READ_FACTS,
            ]}
          ><LoadableFactManagerPage /></PermissionBasedGuard>,
        },
        {
          path: APP_URLS.ORGANIZATIONS.ROOT,
          element: <PermissionBasedGuard
            permissions={[
              WAREHOUSE_PERMISSIONS.CAN_READ_WAREHOUSES,
            ]}
          ><LoadableOrganizationsListPage />
          </PermissionBasedGuard>,
        },
        {
          path: APP_URLS.ORGANIZATIONS.LIST,
          element: <PermissionBasedGuard
            permissions={[
              WAREHOUSE_PERMISSIONS.CAN_READ_WAREHOUSES,
            ]}
          ><LoadableOrganizationsListPage />
          </PermissionBasedGuard>,
        },
        {
          path: APP_URLS.ORGANIZATIONS.ITEM,
          element: <PermissionBasedGuard
            permissions={[
              WAREHOUSE_PERMISSIONS.CAN_READ_WAREHOUSES,
            ]}
          ><LoadableOrganizationPage /></PermissionBasedGuard>,
        },
      ]
    },
  ];
  return useRoutes(allRoutes);
}
